<script>
  import { createEventDispatcher } from 'svelte';
  import FilterButton from './FilterButton.svelte';

  /**
   * props
   */
  export let items = [];
  export let filterFlags;

  const dispatch = createEventDispatcher();

  /**
   * FilterButton click event
   * 
   * @param e
   */
  function handleClick(e) {
    // console.log("handleClick called", e.detail.group, e.detail.val);
    // console.log(`filterFlags[${e.detail['group']}] = ${filterFlags[e.detail.group]}`);

    if(!filterFlags[e.detail.group] || filterFlags[e.detail.group] !== e.detail.val) {
      // filterFlags[group]の値がnullのとき
      // console.log("filterFlags[group]の値がnullのときvalで上書き");
      filterFlags[e.detail.group] = e.detail.val;
    } else {
      // filterFlags[group]の値がvalのとき（クリックされたボタンと同じとき）トグル
      // console.log("filterFlags[group]の値がvalのとき（クリックされたボタンと同じとき）トグル");
      filterFlags[e.detail.group] = null;
    }
    
    /**
     * filterFlags.allのセット
     */
    if(
      filterFlags.kind === null
      && filterFlags.type === null
      && filterFlags.target_age === null
      && filterFlags.price === null
      && filterFlags.hardware === null
      && filterFlags.apptype === null
    ) {
      filterFlags.all = 'all';
    } else {
      filterFlags.all = null;
    }
    console.log(filterFlags);

    // イベントをディスパッチ
    dispatch('filterChanged', {});
  }

  /**
   * ［全アイテム］をクリックしたとき専用のイベント
   * filterFlagsの値をデフォルトに戻す
   */
  function handleClickAllItems() {
    for(const [key, value] of Object.entries(filterFlags)) {
      filterFlags[key] = null;
    }
    filterFlags.all = 'all';
    console.log(filterFlags);

    // イベントをディスパッチ
    dispatch('filterChanged', {});
  }
</script>

<ul class="item-chooser">
  <!-- 全アイテム -->
  <li class="filter-unit filter-all">
    <FilterButton label="全アイテム" group="all" val="all" current="{filterFlags.all}"
    on:filterItem={handleClickAllItems} 
    />
  </li>

  <!-- kind -->
   <li class="filter-unit filter-kind">
    <div class="group-name">タイプ</div>
    <div class="group-btns">
      <FilterButton label="アプリ系" group="kind" val="app" current="{filterFlags.kind}"
        on:filterItem={handleClick}
      />
      <FilterButton label="ガジェット系" group="kind" val="gadget" current="{filterFlags.kind}"
        on:filterItem={handleClick}
      />
      <FilterButton label="マイコンボード系" group="kind" val="micom" current="{filterFlags.kind}"
        on:filterItem={handleClick}
      />
      <FilterButton label="ロボット系" group="kind" val="robot" current="{filterFlags.kind}"
        on:filterItem={handleClick}
      />
      <FilterButton label="センサー・回路系" group="kind" val="sensor" current="{filterFlags.kind}"
        on:filterItem={handleClick}
      />
      <FilterButton label="アンプラグド系" group="kind" val="unplugged" current="{filterFlags.kind}"
        on:filterItem={handleClick}
      />
    </div>
  </li>

  <!-- target age -->
   <li class="filter-unit filter-age">
    <div class="group-name">対象年齢</div>
    <div class="group-btns">
      <FilterButton label="未就学〜" group="target_age" val="nursery" current="{filterFlags.target_age}"
        on:filterItem={handleClick}
      />
      <FilterButton label="小学校低学年〜" group="target_age" val="elementary1" current="{filterFlags.target_age}"
        on:filterItem={handleClick}
      />
      <FilterButton label="小学校中学年〜" group="target_age" val="elementary3" current="{filterFlags.target_age}"
        on:filterItem={handleClick}
      />
      <FilterButton label="小学校高学年〜" group="target_age" val="elementary5" current="{filterFlags.target_age}"
        on:filterItem={handleClick}
      />
      <FilterButton label="中学生〜" group="target_age" val="junior_high" current="{filterFlags.target_age}"
        on:filterItem={handleClick}
      />
    </div>
  </li>

  <!-- hardware -->
   <li class="filter-unit filter-hardware">
    <div class="group-name">使用機器</div>
    <div class="group-btns">
      <FilterButton label="パソコン" group="hardware" val="pc" current="{filterFlags.hardware}"
        on:filterItem={handleClick}
      />
      <FilterButton label="タブレット" group="hardware" val="tablet" current="{filterFlags.hardware}"
        on:filterItem={handleClick}
      />
      <FilterButton label="機器不要" group="hardware" val="none" current="{filterFlags.hardware}"
        on:filterItem={handleClick}
      />
      <FilterButton label="その他" group="hardware" val="other" current="{filterFlags.hardware}"
        on:filterItem={handleClick}
      />
    </div>
  </li>

  <!-- programming type -->
   <li class="filter-unit filter-purpose">
    <div class="group-name">目的</div>
    <div class="group-btns">
      <FilterButton label="クリエイティブ型" group="type" val="make" current="{filterFlags.type}"
        on:filterItem={handleClick}
      />
      <FilterButton label="ステージクリア型" group="type" val="solve" current="{filterFlags.type}"
        on:filterItem={handleClick}
      />
    </div>
  </li>

  <!-- price -->
   <li class="filter-unit filter-price">
    <div class="group-name">価格</div>
    <div class="group-btns">
      <FilterButton label="無料" group="price" val="p0" current="{filterFlags.price}"
        on:filterItem={handleClick}
      />
      <FilterButton label="〜¥5,000" group="price" val="p5000" current="{filterFlags.price}"
        on:filterItem={handleClick}
      />
      <FilterButton label="〜¥10,000"  group="price" val="p10000" current="{filterFlags.price}"
        on:filterItem={handleClick}
      />
      <FilterButton label="〜¥20,000" group="price" val="p20000" current="{filterFlags.price}"
        on:filterItem={handleClick}
      />
      <FilterButton label="〜¥30,000" group="price" val="p30000" current="{filterFlags.price}"
        on:filterItem={handleClick}
      />
      <FilterButton label="¥30,001〜" group="price" val="p30001" current="{filterFlags.price}"
        on:filterItem={handleClick}
      />
    </div>
  </li>

  <!-- apptype -->
   <li class="filter-unit filter-apptype">
    <div class="group-name">動作環境</div>
    <div class="group-btns">
      <FilterButton label="アプリダウンロード型" group="apptype" val="app" current="{filterFlags.apptype}"
        on:filterItem={handleClick}
      />
      <FilterButton label="ブラウザ利用型" group="apptype" val="browser" current="{filterFlags.apptype}"
        on:filterItem={handleClick}
      />
      <FilterButton label="アプリ不要" group="apptype" val="noapp" current="{filterFlags.apptype}"
        on:filterItem={handleClick}
      />
      <FilterButton label="その他" group="apptype" val="other" current="{filterFlags.apptype}"
        on:filterItem={handleClick}
      />
    </div>
  </li>

</ul>
<div>
  <span>{items.length}件</span>
</div>

<style>
.item-chooser {
  margin: 0 0 1.5rem 0;
  padding: 25px 25px 9px 25px;
  border-radius: 10px;
  background: #EAECEF;
  list-style: none;
}

@media(min-width: 993px) {
  .item-chooser {
    padding: 25px 40px 10px 40px;
  }
}

.filter-unit:not(:first-child) {
  display: flex;
  flex-flow: column wrap;
}
@media(min-width: 993px) {
  .filter-unit:not(:first-child) {
    flex-flow: row nowrap;
  }
}

.filter-unit {
  margin-bottom: 16px;
}
@media(min-width: 993px) {
  .filter-unit {
    margin-bottom: 10px;
  }
}

.group-name {
  padding: 3px 0;
  font-size: .875rem;
  font-weight: bold;
}
@media(min-width: 993px) {
  .group-name {
    flex: 0 0 80px;
  }
}

/* show/hide */
@media(max-width: 992px) {
  .filter-unit.filter-hardware,
  .filter-unit.filter-purpose,
  .filter-unit.filter-apptype {
    display: none;
  }
}
</style>